/**
 * Original work Copyright (c) 2019 Burst Apps Team
 */

/**
 * Constants for leasing subtypes
 *
 * @module core
 */
export enum TransactionLeasingSubtype {
    Ordinary = 0
}

